<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Sage</h1>
        </div>
        <el-alert
            v-if="authenticated"
            style="max-width: 200px"
            title="Connected to Sage"
            type="success"
            :closable="false"
            show-icon
        >
        </el-alert>
        <el-alert
            v-if="!authenticated"
            style="max-width: 300px"
            title="Please connect your Sage account."
            type="warning"
            :closable="false"
            show-icon
        >
        </el-alert>
        <div class="mt-20" v-if="can(Permissions.EDIT_SAGE)">
            <el-button @click="authenticate()" type="primary">
                <span v-if="authenticated">Reconnect</span
                ><span v-else>Connect</span>
            </el-button>
        </div>
    </vue-scroll>
</template>

<script>
import auth from "@/mixins/auth";

export default {
    mixins: [auth],
    data() {
        return {
            status: null,
        };
    },
    created() {
        this.getStatus();
    },
    computed: {
        authenticated() {
            return this.data_get(this.status, "authenticated", false);
        },
    },
    methods: {
        authenticate() {
            location.href = `/web-api/sage/redirect`;
        },
        getStatus() {
            axios.get(`/web-api/sage/status`).then((response) => {
                this.status = response.data;
            });
        },
    },
};
</script>

<style scoped></style>
